import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientsServices } from "../../../../../ingredients/services";
import { Globals } from "../../../../../../globals";
import { ProductsServices } from '../../../../services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateIngredientPage } from '../../../../../components/popups/create-ingredient/create-ingredient';
/**
 * Generated class for the ProductPartialFoodcostIngSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-partial-foodcost-ing-select',
  templateUrl: 'product-partial-foodcost-ing-select.html',
})
export class ProductPartialFoodcostIngSelectPage {
  term: string;
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public productsServices: ProductsServices,
    public translate: TranslateService,
    public modalCtrl: ModalController) {
  }

  ionViewWillEnter() {
  }


  insert(proding) {

    if (!this.check(proding.UID)) { //Buscamos si el ingrediente o producto ya esta anadido
      var _array = Array();
      _array.push(proding.UID);
      _array.push(proding.name);
      _array.push(proding.measurement);
      _array.push(proding.providers);
      _array.push(proding.tax);
      _array.push(proding.price_static);
      _array.push(proding.provider_static);
      _array.push(proding.tags);
      if (proding.allergens == undefined) {
        proding.allergens = [];
        _array.push(proding.allergens);
      } else {
        _array.push(proding.allergens);
      }

      //_array.push(proding.allergens);
      _array.push(proding.stock_alert);
      _array.push(proding.stock);
      _array.push(proding.sub_recipe);
      _array.push(0);//cantidad
      _array.push(0);//cantidad bruta
      _array.push(0);//merma
      _array.push(0);//preu final
      _array.push(0);//total
      _array.push(proding.foodcost);
      _array.push(proding.real_weight);
      _array.push('');
      _array.push('');
      _array.push('');
      _array.push('');
      _array.push('ingredient');

      this.productsServices.prodings_array_tmp.push(_array);
      this.productsServices.prodings_array_tmp = [...this.productsServices.prodings_array_tmp];
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-ingrediente') + ' ' + proding.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-ingrediente-esta-anadido-lista'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  check(value) {
    var response = false;
    for (var i = 0; i < this.productsServices.prodings_array_tmp.length; i++) {
      var obj = this.productsServices.prodings_array_tmp[i];
      if (obj[0] == value) {
        response = true;
      }
    }
    return response;
  }

  nextPage() {
    if (this.ingredientsServices.page_active < this.ingredientsServices.pagesIngredients.length) {
      this.ingredientsServices.page_active += 1
    }
    this.ingredientsServices.getListIngredientsMinMax();
    document.getElementById('scroll_ing_select').scrollIntoView({
      behavior: 'smooth'
    });
  }
  previusPage() {
    if (this.ingredientsServices.page_active > 1) {
      this.ingredientsServices.page_active -= 1;
    }
    this.ingredientsServices.getListIngredientsMinMax();
    document.getElementById('scroll_ing_select').scrollIntoView({
      behavior: 'smooth'
    });
  }
  activePage(number) {
    this.ingredientsServices.page_active = number;
    this.ingredientsServices.getListIngredientsMinMax();
    document.getElementById('scroll_ing_select').scrollIntoView({
      behavior: 'smooth'
    });
  }
  clickElement(event) {
    if (event.type == 'click') {
      this.insert(event.row);
    }
  }
  openCreateIngredient() {
    let profileModal = this.modalCtrl.create(CompCreateIngredientPage, {
      origin: 'product'
    });
    profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-partial-foodcost-ing-select/product-partial-foodcost-ing-select.ts